/**
 * @license React
 * react-server-dom-webpack.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

var k = require("react"),
  l = {
    stream: !0
  },
  n = new Map(),
  p = Symbol.for("react.element"),
  q = Symbol.for("react.lazy"),
  r = Symbol.for("react.default_value"),
  t = k.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ContextRegistry;
function u(a) {
  t[a] || (t[a] = k.createServerContext(a, r));
  return t[a];
}
function v(a, b, c) {
  this._status = a;
  this._value = b;
  this._response = c;
}
v.prototype.then = function (a) {
  0 === this._status ? (null === this._value && (this._value = []), this._value.push(a)) : a();
};
function w(a) {
  switch (a._status) {
    case 3:
      return a._value;
    case 1:
      var b = JSON.parse(a._value, a._response._fromJSON);
      a._status = 3;
      return a._value = b;
    case 2:
      b = a._value;
      for (var c = b.chunks, d = 0; d < c.length; d++) {
        var e = n.get(c[d]);
        if (null !== e) throw e;
      }
      c = __webpack_require__(b.id);
      b = "*" === b.name ? c : "" === b.name ? c.__esModule ? c.default : c : c[b.name];
      a._status = 3;
      return a._value = b;
    case 0:
      throw a;
    default:
      throw a._value;
  }
}
function x() {
  var a = y(this, 0);
  return w(a);
}
function z(a, b) {
  return new v(3, b, a);
}
function A(a) {
  if (null !== a) for (var b = 0; b < a.length; b++) {
    (0, a[b])();
  }
}
function C(a, b) {
  if (0 === a._status) {
    var c = a._value;
    a._status = 4;
    a._value = b;
    A(c);
  }
}
function D(a, b) {
  a._chunks.forEach(function (a) {
    C(a, b);
  });
}
function y(a, b) {
  var c = a._chunks,
    d = c.get(b);
  d || (d = new v(0, null, a), c.set(b, d));
  return d;
}
function E(a, b, c) {
  switch (c[0]) {
    case "$":
      if ("$" === c) return p;
      if ("$" === c[1] || "@" === c[1]) return c.substring(1);
      b = parseInt(c.substring(1), 16);
      a = y(a, b);
      return w(a);
    case "@":
      return b = parseInt(c.substring(1), 16), a = y(a, b), {
        $$typeof: q,
        _payload: a,
        _init: w
      };
  }
  return c;
}
function F(a) {
  D(a, Error("Connection closed."));
}
function G(a, b) {
  if ("" !== b) {
    var c = b[0],
      d = b.indexOf(":", 1),
      e = parseInt(b.substring(1, d), 16);
    d = b.substring(d + 1);
    switch (c) {
      case "J":
        b = a._chunks;
        (c = b.get(e)) ? 0 === c._status && (a = c._value, c._status = 1, c._value = d, A(a)) : b.set(e, new v(1, d, a));
        break;
      case "M":
        b = a._chunks;
        c = b.get(e);
        d = JSON.parse(d, a._fromJSON);
        var f = a._bundlerConfig;
        d = f ? f[d.id][d.name] : d;
        f = d.chunks;
        for (var h = 0; h < f.length; h++) {
          var g = f[h];
          if (void 0 === n.get(g)) {
            var B = __webpack_chunk_load__(g),
              m = n.set.bind(n, g, null),
              J = n.set.bind(n, g);
            B.then(m, J);
            n.set(g, B);
          }
        }
        c ? 0 === c._status && (a = c._value, c._status = 2, c._value = d, A(a)) : b.set(e, new v(2, d, a));
        break;
      case "P":
        a._chunks.set(e, z(a, u(d).Provider));
        break;
      case "S":
        c = JSON.parse(d);
        a._chunks.set(e, z(a, Symbol.for(c)));
        break;
      case "E":
        b = JSON.parse(d);
        c = Error(b.message);
        c.stack = b.stack;
        b = a._chunks;
        (d = b.get(e)) ? C(d, c) : b.set(e, new v(4, c, a));
        break;
      default:
        throw Error("Error parsing the data. It's probably an error code or network corruption.");
    }
  }
}
function H(a) {
  return function (b, c) {
    return "string" === typeof c ? E(a, this, c) : "object" === typeof c && null !== c ? (b = c[0] === p ? {
      $$typeof: p,
      type: c[1],
      key: c[2],
      ref: null,
      props: c[3],
      _owner: null
    } : c, b) : c;
  };
}
function I(a) {
  var b = new TextDecoder(),
    c = new Map();
  a = {
    _bundlerConfig: a,
    _chunks: c,
    readRoot: x,
    _partialRow: "",
    _stringDecoder: b
  };
  a._fromJSON = H(a);
  return a;
}
function K(a, b) {
  function c(b) {
    var h = b.value;
    if (b.done) F(a);else {
      b = h;
      h = a._stringDecoder;
      for (var g = b.indexOf(10); -1 < g;) {
        var f = a._partialRow;
        var m = b.subarray(0, g);
        m = h.decode(m);
        G(a, f + m);
        a._partialRow = "";
        b = b.subarray(g + 1);
        g = b.indexOf(10);
      }
      a._partialRow += h.decode(b, l);
      return e.read().then(c, d);
    }
  }
  function d(b) {
    D(a, b);
  }
  var e = b.getReader();
  e.read().then(c, d);
}
exports.createFromFetch = function (a, b) {
  var c = I(b && b.moduleMap ? b.moduleMap : null);
  a.then(function (a) {
    K(c, a.body);
  }, function (a) {
    D(c, a);
  });
  return c;
};
exports.createFromReadableStream = function (a, b) {
  b = I(b && b.moduleMap ? b.moduleMap : null);
  K(b, a);
  return b;
};
exports.createFromXHR = function (a, b) {
  function c() {
    for (var b = a.responseText, c = f, d = b.indexOf("\n", c); -1 < d;) {
      c = e._partialRow + b.substring(c, d), G(e, c), e._partialRow = "", c = d + 1, d = b.indexOf("\n", c);
    }
    e._partialRow += b.substring(c);
    f = b.length;
  }
  function d() {
    D(e, new TypeError("Network error"));
  }
  var e = I(b && b.moduleMap ? b.moduleMap : null),
    f = 0;
  a.addEventListener("progress", c);
  a.addEventListener("load", function () {
    c();
    F(e);
  });
  a.addEventListener("error", d);
  a.addEventListener("abort", d);
  a.addEventListener("timeout", d);
  return e;
};